<template lang="html">
  <el-form ref="form" v-form :model="form" addAction="advertisement/insertAdvertisement.action" editAction="advertisement/updateAdvertisement.action" selectAction="advertisement/selectAdvertisementInfo.action" :rules="rules" label-width="150px">
      <el-col :span="12">

          <el-form-item label="输入链接" prop="link">
              <el-input type="text" v-model="form.link" placeholder="请输入微信文章链接或crm表单链接（否则在小程序中无法打开）"></el-input>
          </el-form-item>

          <el-form-item label="上传封面图" prop="imgLink">
              <!-- <el-upload  multiple full :action="baseUrl+'upload/uploadPic'" v-model="form.imgLink"  :data="{floder:'applyBusinessHeader'}" list-type="picture-card" :file-list="form.imgLink">
                  <i class="el-icon-plus"></i>
              </el-upload> -->
              <el-upload  accept="image/*" class="avatar-uploader" v-model="form.imgLink"  :http-request="onHttpRequest" action="upload/uploadPic" :show-file-list="false" :data="{floder:'plushBusinessHeader'}" >
                  <img v-if="form.imgLink" :src="form.imgLink.url" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <p style="color:#666;">图片尺寸：750*420px，用于首页banner展示！</p>
          </el-form-item>

          <el-form-item v-belong-to-admin label="展示渠道" prop="channelIds">
            <channel-select ref="channelSelect" :multiple="true" @change="channelIdsChange"></channel-select>
          </el-form-item>
      </el-col>

      <el-col>
          <el-form-item>
              <el-button type="primary">保存</el-button>
              <p style="color:#666;">发布成功后，将展示在最前面（按照更新时间由近到远排序）</p>
          </el-form-item>

      </el-col>

  </el-form>
</template>

<script>
import Config from '@/framework/configs/Config'
import BasicPager from '@/mixins/BasicPager'
import BasicModel from '@/framework/basic/BasicModel'
import channelSelect from '@/components/channelSelect'
export default {

  extends: BasicPager,
  components: {
    channelSelect
  },
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      areaList: [],
      loginPath: '',
      form: {
        id: null,
        link: '',
        imgLink: null,
        channelIds: [],
        isSxb: 0
      },
      rules: {
        title: [{
          required: true,
          message: '标题不能为空！'
        }],
        link: [{
          required: true,
          message: '链接不能为空！'
        }],
        channelIds: [{
          required: true,
          message: '展示渠道不能为空！'
        }]
      }
    }
  },
  created: function () {
    this.form.id = this.$route.params.id
    if (this.loginInfo.loginPath == 'channel') {
      this.loginPath = this.loginInfo.loginPath
      this.form.channelIds = [this.loginInfo.id]
      this.form.isSxb = 0
    } else {
      this.form.isSxb = 1
    }
    this.loadAreaList()
  },
  methods: {
    channelIdsChange: function (channelIds) {
      if (channelIds && channelIds.length) {
        this.form.channelIds = channelIds
      } else {
        this.form.channelIds = []
      }
    },
    onFilterParams: function (params) {

    },
    onSelectInfo: function (info) {
      let _this = this
      if (info.datas.channelIds) {
        let array = info.datas.channelIds.split(',')
        let channelIds = []
        for (var i = 0; i < array.length; i++) {
          let item = array[i]
          channelIds.push(parseInt(item))
        }

        this.$nextTick(function () {
          _this.$refs['channelSelect'].setChannelIds(channelIds)
        })
      }
    },
    loadAreaList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.areaList = dataInfo.datas
        }
      }

      BasicModel.get(_this, '/lcwpArea/findAreaList.action', null, listener)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
